'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFinalUtms = getFinalUtms;

exports.default = function () {
  // enrich the event with
  // this reproduce the behavior that was before in SignupEventLogger.js
  // - intent
  // - signup type
  // - referrer params
  // - utm/hubs data
  // - if on 2nd part of email verification, immediately set the email onto the tracker

  // intent
  var properties = {
    intent: _AppConfigContainer2.default.get('intentKey')
  };

  if (properties.intent === 'connectIntegration') {
    properties.integration = _AppConfigContainer2.default.get('integrationKey');
  }

  // signup type
  properties.signupType = (0, _isApp.appName)();

  //email if back from email verification link
  var requestedStep = (0, _getRequestedStepFromPath.getRequestedStepFromPath)();
  var emailParam = _QueryParamsContainer2.default.get('email');
  if (requestedStep === _appVerifiedStepRoutes2.default.COMPLETE_VERIFICATION && emailParam) {
    properties.email = emailParam;
  }

  // referrer
  var referrer = (0, _Analytics.getReferrer)();
  if (referrer) {
    var refererUrl = new _Url2.default(referrer);
    properties['Referrer Url'] = refererUrl.href;
    properties['Referrer Host'] = refererUrl.hostname;
    properties['Referrer Path'] = refererUrl.pathname;

    var params = refererUrl.search;
    if (params && params.indexOf('?') >= 0) {
      // strip the ?
      params = refererUrl.search.substr(refererUrl.search.indexOf('?') + 1);
    }
    properties['Referrer Params'] = params;
  }

  var utmsFiltered = (0, _utmHelpers.parseUtmData)(_QueryParamsContainer2.default.getJS());
  // exp params
  var expParams = (0, _utmHelpers.getOnlyExpParams)(utmsFiltered);
  properties = Object.assign(properties, expParams);

  // set hubs params, for hubs params to be mapped to utm, overwrite utm
  var howUtms = getFinalUtms(utmsFiltered);

  // set utms
  Object.keys(howUtms).forEach(function (key) {
    var utmValue = howUtms[key];
    if (utmValue) {
      properties['how_' + key] = utmValue;
    }
  });

  var maybeSignupModeOverride = _QueryParamsContainer2.default.get(_SignupQueryParamKeys2.default.SIGNUP_MODE);
  if (maybeSignupModeOverride) {
    properties.signupMode = maybeSignupModeOverride;
  }

  return properties;
};

var _Url = require('urlinator/Url');

var _Url2 = _interopRequireDefault(_Url);

var _AppConfigContainer = require('../globals/AppConfigContainer');

var _AppConfigContainer2 = _interopRequireDefault(_AppConfigContainer);

var _mappedUtmToHubs = require('../constants/mappedUtmToHubs');

var _mappedUtmToHubs2 = _interopRequireDefault(_mappedUtmToHubs);

var _utmHelpers = require('../utils/utmHelpers');

var _isApp = require('../utils/isApp');

var _Analytics = require('../utils/Analytics');

var _QueryParamsContainer = require('../globals/QueryParamsContainer');

var _QueryParamsContainer2 = _interopRequireDefault(_QueryParamsContainer);

var _SignupQueryParamKeys = require('signup-ui-core/constants/SignupQueryParamKeys');

var _SignupQueryParamKeys2 = _interopRequireDefault(_SignupQueryParamKeys);

var _appVerifiedStepRoutes = require('../constants/appVerifiedStepRoutes');

var _appVerifiedStepRoutes2 = _interopRequireDefault(_appVerifiedStepRoutes);

var _getRequestedStepFromPath = require('../utils/getRequestedStepFromPath');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transformReferrerMediumToHubs(finalUtms) {
  //if there's no explicit medium/source in the url
  //and there is a medium source in the calculated
  //and the medium is referrer
  //means that medium / source was implied , so should be replaced
  //with hubs_
  var hasUrlUtmMedium = !!_QueryParamsContainer2.default.get('utm_medium');
  var hasUrlUtmSource = !!_QueryParamsContainer2.default.get('utm_source');
  var hasUtmMedium = !!finalUtms['utm_medium'];
  var hasUtmSource = !!finalUtms['utm_source'];
  var mediumValue = finalUtms['utm_medium'];
  if (!hasUrlUtmMedium && !hasUrlUtmSource && hasUtmMedium && hasUtmSource && mediumValue === 'referral') {
    var sourceValue = finalUtms['utm_source'];
    delete finalUtms['utm_medium'];
    delete finalUtms['utm_source'];
    finalUtms['hubs_medium'] = mediumValue;
    finalUtms['hubs_source'] = sourceValue;
  }
  return finalUtms;
}

function mapHubsToUtm(hubsToUtm, howUtms) {
  var forAmplitude = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  Object.keys(_mappedUtmToHubs2.default).forEach(function (mappingSource) {
    var mappingDestination = _mappedUtmToHubs2.default[mappingSource];
    // set value in how_utm as the value found in hubs_utm ( if present ). It will replace old value, otherwise will be added
    var hubsOverrideValue = hubsToUtm[mappingSource];
    if (hubsOverrideValue) {
      if (forAmplitude) {
        howUtms[mappingDestination] = hubsOverrideValue;
      } else {
        howUtms[mappingSource] = hubsOverrideValue;
      }
    }
  });

  return howUtms;
}

function getFinalUtms(utmsFiltered) {
  var shouldTransformReferrerToHubs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var forAmplitude = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  var howUtms = (0, _utmHelpers.maybeSetDocumentReferrer)((0, _utmHelpers.mergeFromExp)(utmsFiltered));
  // contains the hubs_* parameters with defined values that should replace the values of relevant utm_*
  var hubsToUtm = (0, _utmHelpers.hubsToUtmData)(_QueryParamsContainer2.default.getJS());
  // contains additional hubs_ parameters, this won't be sent to amplitude (for now)
  // const additionalHubs = hubs.get('hubs').toJS();
  howUtms = mapHubsToUtm(hubsToUtm, howUtms, forAmplitude);
  //if utm_medium / source are inferred from the referrer (not explicit in the url) we
  // transform them back to be hubs_ so that signup after verification will pick them up for amplitude tracking
  // but GA won't override those originated in the customer cookie
  howUtms = shouldTransformReferrerToHubs ? transformReferrerMediumToHubs(howUtms) : howUtms;
  return howUtms;
}